import { OrderHistoryQuotationState } from '../../model/order-history.model';
import { OrderHistoryActions } from '../actions/index';
import { createReducer, on } from '@ngrx/store';

export const initialState: OrderHistoryQuotationState = {
    quotaion: false,
    queryFromSearch: '',
    filterQuery: '',
    currentPage: 0
};

export const orderHistoryQuatationReducer = createReducer(
    initialState,
    on(OrderHistoryActions.qutotationSalesValue, (state, { quotaion }) => ({
        ...state,
        quotaion,
        currentPage: 0,
        filterQuery: ''
    })),
    on(OrderHistoryActions.setQueryFromSearch, (state, { queryFromSearch }) => ({
        ...state,
        queryFromSearch,
        currentPage: 0
    })),
    on(OrderHistoryActions.setFilterQuery, (state, { filterQuery }) => ({
        ...state,
        filterQuery: filterQuery,
    })),
    on(OrderHistoryActions.setCurrentPage, (state, { currentPage }) => ({
        ...state,
        currentPage,
    })),
    on(OrderHistoryActions.clearOrderHistoryState,
        () => ({ ...initialState })
    )
)